var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('button',{on:{"click":function($event){return _vm.test()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }